// Reader-facing copy for the existing headwear routes. SKU selection, catalog
// filters, prices and inventory remain owned by their existing source records.
export const headwearContent = Object.freeze({
  'printed-caps': {
    title: 'כובעים עם הדפס לצוות שלכם',
    description: 'מתחילים בכמות ובמחיר: כובע בסיסי KR2020 עם הדפסה בחזית לצוות, לקבוצה או לאירוע. משווים דוגמאות מחיר וממשיכים ישירות לבחירת צבע, מידה וכמות.',
    sectionHeading: 'בוחרים כובע ומכינים את העיצוב',
    selectionIntro: 'הכובעים מוצגים ללא מיתוג. בכל דף מוצר אפשר לראות חזית וגב ולבחור צבע ועיצוב.',
    spotlight: [
      { title: 'בוחרים דגם', body: 'פותחים את דף הדגם כדי לראות את הצבעים ואפשרויות המיתוג שלו.' },
      { title: 'בוחרים צבע וכמות', body: 'בדף המוצר בוחרים צבעים, מזינים כמות לכל צבע ובוחרים אזור הדפסה מתוך האפשרויות של הדגם.' },
      { title: 'מצרפים עיצוב', body: 'מעלים קובץ לאזור ההדפסה שנבחר, מוסיפים הערות לפי הצורך ובודקים את הסיכום לפני ההוספה לעגלה.' },
    ],
    heroPoints: ['בחירת דגם וצבע', 'כמות לכל צבע', 'עיצוב באזורי ההדפסה של הדגם'],
    relatedKeys: ['embroidered-caps', 'branded-caps'],
  },
  'embroidered-caps': {
    title: 'כובעים לרקמה עם הלוגו שלכם',
    description: 'בוחרים כובע לצוות או למתנה ממותגת, ובודקים בדף הדגם את אפשרויות הרקמה, הצבעים והכמויות. להתאמת העיצוב לשיטה אפשר לפנות אלינו.',
    sectionHeading: 'מה לבדוק לפני שמזמינים כובע לרקמה?',
    spotlight: [
      { title: 'הדגם והסגירה', body: 'הדגמים נבדלים בצורה, בהרכב ובסגירה. פתחו את דף המוצר וקראו את הפרטים של הדגם שבחרתם.' },
      { title: 'הלוגו ואזור המיתוג', body: 'בדקו את אזורי המיתוג ואת השיטות המוצגים בדף המוצר. אם יש שאלה לגבי התאמת הלוגו לרקמה, צרפו את העיצוב לפנייה.' },
      { title: 'צבעים וכמויות', body: 'הכינו את הכמות הנדרשת מכל צבע. הבחירות והמחיר מוצגים בדף המוצר ובסיכום ההזמנה.' },
    ],
    heroPoints: ['לוגו ועיצוב לרקמה', 'בחירת צבע וכמות', 'אפשרויות מיתוג לפי הדגם'],
    relatedKeys: ['printed-caps', 'branded-caps'],
  },
  'branded-caps': {
    title: 'כובעים ממותגים לעסקים ולצוותים',
    description: 'לצוות, לאירוע עסקי או למתנה ממותגת: משווים דגמי כובעים, בוחרים צבע וכמות וממשיכים לאפשרויות המיתוג בדף המוצר.',
    sectionHeading: 'מתאימים את הכובע להזמנה של הצוות',
    spotlight: [
      { title: 'בוחרים את צורת הכובע', body: 'השוו את דגמי המצחייה והרשת שמוצגים כאן. לכל דגם פרטי מוצר וצבעים משלו.' },
      { title: 'מכינים כמויות לפי צבע', body: 'אספו את הכמויות של הצוות והזינו את הבחירות בדף הדגם. אפשר לבדוק את פרטי ההזמנה לפני שמוסיפים לעגלה.' },
      { title: 'בוחרים מיקום ללוגו', body: 'בדף המוצר בוחרים מתוך אזורי המיתוג והשיטות המוצגים בו. להסבר על ההבדלים בין השיטות אפשר לעבור לעמוד שיטות המיתוג.' },
    ],
    heroPoints: ['לצוותים ולאירועים', 'בחירת דגם וצבע', 'לוגו באזורי המיתוג של המוצר'],
    relatedKeys: ['printed-caps', 'embroidered-caps', 'tembel-hats'],
  },
  'tembel-hats': {
    title: 'כובעי טמבל וכובעי פטרייה',
    description: 'כובעי פטרייה מתוך הקטלוג לבחירה עבור קבוצה, קייטנה או טיול. משווים את הדגמים וממשיכים לצבעים, לכמויות ולאפשרויות המיתוג של כל מוצר.',
    sectionHeading: 'משווים את הדגמים לפני בחירת הכמויות',
    spotlight: [
      { title: 'הרכב ומבנה', body: 'בקטלוג מוצגים דגמים שונים של כובעי פטרייה. קראו את הרכב החומר ואת פרטי המבנה בדף של כל דגם.' },
      { title: 'מידת הכובע', body: 'בדקו את המידה הרשומה בפרטי המוצר לפני ההזמנה לקבוצה. אל תניחו שכל דגם או צבע מוצע באותן אפשרויות.' },
      { title: 'עיצוב לקבוצה', body: 'לאחר בחירת הדגם והצבע, בדקו את אזורי המיתוג והזינו את הכמות. לשאלה לגבי עיצוב או הזמנה לקבוצה אפשר לפנות אלינו.' },
    ],
    heroPoints: ['דגמי כובעי פטרייה', 'פרטי חומר ומידה בכל מוצר', 'מיתוג לפי אפשרויות הדגם'],
    taxonomyNote: 'הדגמים בעמוד הזה מופיעים בקטלוג תחת כובעי פטרייה. כובעי מצחייה וכובעי לגיונר מוצגים בנפרד בקטלוג.',
    relatedKeys: ['branded-caps'],
  },
  'kippot-events': {
    title: 'כיפות לאירועים בעיצוב שלכם',
    description: 'לבר מצווה, לחתונה או לאירוע משפחתי: משווים כיפות סאטן, פשתן, זמש וקטיפה מתוך הקטלוג. את הכמות ואפשרויות המיתוג בוחרים בדף הדגם.',
    sectionHeading: 'מכינים את פרטי ההזמנה לאירוע',
    spotlight: [
      { title: 'החומר והמידה', body: 'לכל דגם חומר ומידה משלו. פתחו את פרטי המוצר והשוו לפני בחירת הכיפות לאירוע.' },
      { title: 'הכמות והעיצוב', body: 'הכינו את הכמות המבוקשת ואת הטקסט או העיצוב לאירוע. בדף המוצר בוחרים מתוך אפשרויות המיתוג של הדגם.' },
      { title: 'מועד האירוע', body: 'אם הכיפות נדרשות לתאריך קבוע, בדקו איתנו את התאמת ההזמנה למועד לפני שמזמינים.' },
    ],
    heroPoints: ['דגמי סאטן, פשתן, זמש וקטיפה', 'עיצוב לאירוע', 'כמות לפי בחירת הדגם'],
    relatedKeys: ['embroidered-kippot'],
  },
  'embroidered-kippot': {
    title: 'כיפות לרקמה לאירועים',
    description: 'בוחרים דגם כיפה ובודקים את אפשרויות הרקמה והמיתוג שלו. הכינו את העיצוב והכמות, ופנו אלינו אם דרושה התאמה של הקובץ או השיטה.',
    sectionHeading: 'מתחילים בדגם ובקובץ העיצוב',
    spotlight: [
      { title: 'בחירת הכיפה', body: 'השוו את החומר ואת המידה בדפי דגמי הכיפות המוצגים כאן. בחירת דגם אינה מחליפה בדיקה של אפשרויות המיתוג שלו.' },
      { title: 'בדיקת הרקמה', body: 'בדקו את אזורי המיתוג והשיטות בדף הדגם. להתאמה של שם, לוגו או עיצוב לרקמה אפשר לצרף את הקובץ לפנייה.' },
      { title: 'כמות ומועד', body: 'הכינו את הכמות המבוקשת. אם ההזמנה מיועדת לאירוע במועד קבוע, בדקו איתנו את לוח הזמנים לפני ההזמנה.' },
    ],
    heroPoints: ['בחירת דגם וחומר', 'קובץ עיצוב לרקמה', 'בדיקת כמויות ומועד'],
    relatedKeys: ['kippot-events'],
  },
});
